import { useDispatch, useSelector } from 'react-redux'
import { getBlockRichCheckoutOrderDialog } from '../../Selectors'
import { setBlockRichCheckoutOrderDialog } from '../../ActionCreators'
import ConfirmModal from '../../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../../strings'

const VNRichCheckoutDialog = () => {
  const dispatch = useDispatch()
  const blockedRichCheckoutOrder = useSelector(getBlockRichCheckoutOrderDialog)
  const isOpened = blockedRichCheckoutOrder?.get('open')
  const headerText = blockedRichCheckoutOrder?.get('title')

  if (!isOpened) {
    return null
  }

  return (
    <ConfirmModal
      open={isOpened}
      headerText={headerText}
      singleButtonOnly={true}
      buttonTwoText={APPLICATION_STRINGS.OKAY_BUTTON_TEXT}
      onButtonTwoClick={() => {
        dispatch(setBlockRichCheckoutOrderDialog(false))
      }}
    />
  )
}

export default VNRichCheckoutDialog
